import React from 'react';
import ScrollToBottom from 'react-scroll-to-bottom';

import Message from './Message';
import Spinner from '../UI/Spinner';

const ChatWindow = (props) => {

    let ChatWindow = <ScrollToBottom scrollViewClassName="chat-window" followButtonClassName="follow-button">
        <div className="messages">
            {!props.isUserSelected && <h1 className="messages-help">Select a contact to start chatting with!</h1>}
            {props.messages && props.messages.length === 0 && <h1 className="messages-help">No Messages</h1>}
            {props.messages !== null && props.messages.map((message, index) => {
                return <Message
                    key={props.currentUser + index}
                    isMe={(props.currentUser === message.from._id) || (props.currentUser === message.from.userId)}
                    from={`${message.from.firstName} ${message.from.lastName}`}
                    to={`${message.to.firstName} ${message.to.lastName}`}
                    text={message.text} />
            })}
        </div>
    </ScrollToBottom>;

    if (props.isLoading) {
        ChatWindow = <Spinner />
    }

    return ChatWindow;
}

export default ChatWindow;